import { render } from "./Generate.vue?vue&type=template&id=a97ce832"
import script from "./Generate.vue?vue&type=script&lang=js"
export * from "./Generate.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__